<template>

    <div class="submitterdetail_container">
        <div class="submiterDetail_wrapper d-flex gap-4 flex-wrap" v-if="submitterData">
            <div class="submitterDetails_avatar">
                <img src="../../../assets/images/user.svg" class="rounded-circle" />
            </div>
            <div class="submitterDetails_content">
                <div class="d-flex align-items-center submitterDetails_name gap-3 mb-2 flex-wrap">
                    <h3 class="clr-title fw-bold mb-0"> {{ submitterData.fullname || `${submitterData.first_name}
                        ${submitterData.last_name}` || 'N/A' }} </h3>
                    <span class="submitterDetails_grouptype clr-primary font-12">
                        {{ submitterData.user_type || 'N/A' }}
                    </span>
                </div>

                <div class="submitterDetails_infowrapper d-flex flex-column gap-1">
                    <div class="submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap">
                        <template v-if="submitterData.email">
                            <a href="`mailto:${submitterData.email}`"
                                class="user_email text-highlight d-flex align-items-center gap-1 clr-primary upload-file-type">
                                <span
                                    class="icon d-flex align-items-center justify-content-center flex-shrink-0 text-color fw-normal clr-bold-grey font-14">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                            d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm8-7L4 8v10h16V8zm0-2l8-5H4zM4 8V6v12z" />
                                    </svg>
                                </span>
                                {{ submitterData.email || 'N/A' }}
                            </a>
                        </template>
                        <span class="dots"> </span>
                        <template>
                            <a href="`tel:${submitterData.phone}`"
                                class="user_phonenumber text-highlight d-flex align-items-center gap-1 clr-primary upload-file-type">
                                <span
                                    class="icon d-flex align-items-center justify-content-center flex-shrink-0 text-color fw-normal clr-bold-grey font-14">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                        <g fill="none" fill-rule="evenodd">
                                            <path
                                                d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                                            <path fill="currentColor"
                                                d="M8.172 15.829c3.845 3.845 7.408 4.266 8.454 4.305c1.264.046 2.554-.986 3.112-2.043c-.89-1.044-2.049-1.854-3.318-2.732c-.749.748-1.672 2.138-2.901 1.64c-.699-.281-2.425-1.076-3.933-2.585S7.283 11.18 7 10.482c-.498-1.231.896-2.156 1.645-2.905c-.878-1.29-1.674-2.479-2.716-3.324c-1.072.56-2.11 1.84-2.063 3.121c.039 1.046.46 4.609 4.306 8.455m8.38 6.304c-1.44-.053-5.521-.617-9.795-4.89c-4.273-4.274-4.836-8.354-4.89-9.795c-.08-2.196 1.602-4.329 3.545-5.162a1.47 1.47 0 0 1 1.445.159c1.608 1.173 2.717 2.95 3.67 4.342A1.504 1.504 0 0 1 10.35 8.7l-1.356 1.357C9.309 10.752 9.95 11.95 11 13s2.248 1.691 2.944 2.006l1.355-1.356a1.5 1.5 0 0 1 1.918-.171c1.42.984 3.088 2.077 4.304 3.634a1.47 1.47 0 0 1 .189 1.485c-.837 1.953-2.955 3.616-5.158 3.535" />
                                        </g>
                                    </svg>
                                </span>
                                {{ submitterData.phone || 'N/A' }}
                            </a>
                        </template>
                    </div>
                    <div class="submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap">
                        <!-- <div class="clr-title">
                            Register :
                            <span class="clr-bold-grey"> N/A</span>

                        </div> -->
                        <!-- <span class="dots"> </span> -->
                        <div class="clr-title">
                            Created On :
                            <span class="clr-bold-grey">{{ formatDate(submitterData.created_at) }}</span>
                        </div>
                    </div>
                    <div class="submitterDetails_info--items d-flex align-items-center gap-2 flex-wrap">
                        <div class="clr-title">
                            Device :
                            <span class="clr-bold-grey">{{ submitterData.device || 'N/A' }}</span>
                        </div>
                        <span class="dots"> </span>
                        <div class="clr-title">
                            Last Login IP :
                            <span class="clr-bold-grey">{{ submitterData.last_login_ip || 'N/A' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center p-4">
            <div class="text-muted">Loading submitter details...</div>
        </div>
    </div>
</template>

<script>
// import carousel from 'vue-owl-carousel';
export default {
    name: "TicketSubmitterDetail",
    // components: { OwlCarousel: carousel },
    props: {
        ticketData: {
            type: Object,
            default: () => null
        },
        formatDate: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            responsiveOptions: {
                0:
                    { items: 1, }, 768: { items: 2, }, 992: { items: 3, },
            },
        };
    },
    computed: {
        submitterData() {
            return this.ticketData?.submitter || null;
        }
    },
};
</script>

<style scoped>
.submiterDetail_wrapper .submitterDetails_avatar img {
    width: 52px;
    height: 52px;
}

.submitterdetail_Infocard {
    padding: 14px 16px;
}

.submiterDetail_wrapper .submitterDetails_content .submitterDetails_grouptype {
    border: 1px solid var(--rep-primary-clr);
    background: #03c3ec10;
    padding: 4px 12px;
    border-radius: 30px;
}

.submitterDetails_info--items .text-highlight .icon {
    color: var(--rep-bold-grey-clr) !important;
}

.submitterdetail_container .dots {
    background-color: #a6a6a6;
    width: 5px;
    height: 5px;
    border-radius: 50%;
}


.accordion-section .planInfo__card--list .plan_name {
    display: list-item;
    list-style-type: disc;
    margin-left: 15px;
}

.accordion-section .card {
    border: 0;
    border-radius: 0;
    box-shadow: none;
}

.accordion-section .card .card-body {
    padding: 0;
    border-radius: 0;
    border: 0;
}

.accordion-section .card .card-body .accordion-item {
    border: 0 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18) !important;
    border-radius: 0;
    padding-bottom: 20px;
    margin-bottom: 20px;
}

.accordion-section .card .card-body .accordion-item .card-header {
    background-color: #fff;
}

.accordion-section .card .card-body .accordion-item .card-header button.not-collapsed .icon-wrapper {
    transform: rotate(180deg);
}

.accordion-section .card .card-body .accordion-item .card-header button,
.accordion-section .card .card-body .accordion-item .card-header button:hover,
.accordion-section .card .card-body .accordion-item .card-header button:active {
    outline: none;
    box-shadow: none;
    color: var(--rep-title-clr);
    border: 0;
}

.document-section .ticket_documentInfo {
    padding: 16px;
    border: 1px solid #d7e1ea;
    border-radius: 6px;
}

.document-section .ticket_documentInfo .icon-wrapper {
    width: 34px;
}

.document-section .systemId_wrapper .systemId_name {
    border-radius: 6px;
}
</style>
